import { EntityId } from "@reduxjs/toolkit";

import { streamingApi } from "./base.api";
import { CreateLiveStreamRequest } from "types/CreateLiveStreamRequest";
import { StreamQualityType } from "types/StreamQualityType";

const BASE_PATH = "/streaming-pod-manager";

export const streamingPodManagerApi = streamingApi.injectEndpoints({
    endpoints: (build) => ({
        createLiveStream: build.mutation<
            {
                streamQuality: StreamQualityType;
                hls: string;
            },
            CreateLiveStreamRequest
        >({
            query: (body) => ({
                url: `${BASE_PATH}/LiveStream`,
                method: "POST",
                body,
                headers: {
                    "diagnostic-correlation-id": body.correlationId,
                },
            }),
        }),
        createPlaybackSession: build.mutation<
            string,
            {
                siteId: EntityId;
            }
        >({
            query: (body) => ({
                url: `${BASE_PATH}/playbacksession`,
                method: "POST",
                body,
            }),
            transformResponse: (response: { sessionId: string }) => {
                return response.sessionId;
            },
        }),
        extendPlaybackSession: build.query<
            undefined,
            {
                sessionId: string;
                extendBy: string;
            }
        >({
            query: (args) => ({
                url: `${BASE_PATH}/playbacksession/${args.sessionId}/extendsession`,
                method: "PUT",
                body: JSON.stringify(args.extendBy),
            }),
        }),
        createPlaybackStream: build.mutation<
            string,
            {
                sessionId: EntityId;
                deviceId: EntityId;
                recordingId: EntityId;
                startTime: string;
                originalStartTime: string;
            }
        >({
            query: (args) => ({
                url: `${BASE_PATH}/playbacksession/${args.sessionId}/devices/${args.deviceId}/recordings/${args.recordingId}/stream`,
                method: "POST",
                params: {
                    startTime: args.startTime,
                    originalStartTime: args.originalStartTime,
                },
            }),
            transformResponse: (response: { hls: string }) => {
                return response.hls;
            },
        }),
        createDiagnosticsSession: build.mutation<string, unknown>({
            query: (body) => ({
                url: `${BASE_PATH}/diagnosticsession`,
                method: "POST",
                body,
            }),
            transformResponse: (response: { sessionId: string }) => {
                return response.sessionId;
            },
        }),
        extendDiagnosticsSession: build.query<
            undefined,
            {
                sessionId: string;
                extendBy: string;
            }
        >({
            query: (args) => ({
                url: `${BASE_PATH}/diagnosticsession/${args.sessionId}/extendsession`,
                method: "PUT",
                body: JSON.stringify(args.extendBy),
            }),
        }),
        startDiagnosticsTestStream: build.mutation<
            string,
            {
                sessionId: EntityId;
            }
        >({
            query: (args) => ({
                url: `${BASE_PATH}/diagnosticsession/${args.sessionId}/startteststream`,
                method: "POST",
                headers: {
                    "diagnostic-correlation-id": args.sessionId.toString(),
                },
            }),
            transformResponse: (response: { hls: string }) => {
                return response.hls;
            },
        }),
    }),
    overrideExisting: true,
});

export const {
    useCreateLiveStreamMutation,
    useCreatePlaybackSessionMutation,
    useCreatePlaybackStreamMutation,
    useExtendPlaybackSessionQuery,
    useCreateDiagnosticsSessionMutation,
    useExtendDiagnosticsSessionQuery,
    useStartDiagnosticsTestStreamMutation,
} = streamingPodManagerApi;
